import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import s from './AIChatPlayground.scss';
import { AIChatPlaygroundNav } from '../Nav/AIChatPlaygroundNav';
import { Tab } from '../../aIChatPlaygroundInterface';
import { AIChatPlaygroundChatTab } from '../Tab/AIChatPlaygroundChatTab';
import { AIChatPlaygroundSettingsTab } from '../SettingsTab/AIChatPlaygroundSettingsTab';
import { Container } from '../../../../symphony';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';
import { IMaterialInfo, IMaterialSolutionSubmission, IMaterialStatus } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { AIChatPlaygroundErrorModal } from '../ErrorModal/AIChatPlaygroundErrorModal';

interface IAIChatPlaygroundProps {
	data: IMaterialInfo,
	solveMaterialCallback: (
		statusChanges: IMaterialStatus[],
		solutions: IMaterialSolutionSubmission[],
		materialInfo?: IMaterialInfo,
	) => void;
}

export const AIChatPlayground = ({ data, solveMaterialCallback }: IAIChatPlaygroundProps) => {
	useStyles(s);
	const { configs } = useContainerData(aIChatPlaygroundContext.value, AIChatPlaygroundStore, ['configs']);
	const { initHandler } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);

	useEffect(() => {
		initHandler(data, solveMaterialCallback);
	}, []);

	if (!configs) {
		return null;
	}

	return (
		<div className="ai-chat-playground">
			<AIChatPlaygroundNav />
			{
				configs.selectedTab === Tab.Chat
					? <AIChatPlaygroundChatTab />
					: <AIChatPlaygroundSettingsTab />
			}
			<AIChatPlaygroundErrorModal />
		</div>
	);
};
